import type { ManualEditEntitiesEnum } from "./common";

// The `manualCreationSaveFactory`, `manualCreationDraftFactory` and `manualSaveEditFactory` factories
// were lifted into the page-agnostic `functional-areas/instruments-editor/repository` so functional
// areas (e.g. portfolio-lab) can reuse them without depending on a page module. Import
// `instrumentsEditorRepository` from there instead.

//create const file
export const errorMessageNameRequired: Record<ManualEditEntitiesEnum, string> = {
	INVESTMENT: "Please provide a name for your portfolio",
	INVESTMENT_DRAFT: "Please provide a name for your portfolio",
	BENCHMARK: "Please provide a name for your benchmark",
	REFERENCE: "Please provide a name for your reference",
	UNIVERSE: "Please provide a name for your universe",
	INVESTMENT_ENHANCEMENT: "Please provide a name for your portfolio",
};
